import axios from 'axios';

const HARDCODED_PRICES = {
  Простой: {
    price: '',
    discountedPrice: '26',
    discountedPercent: '',
    modalPrice: '26'
  },
  Бронза: {
    price: '',
    discountedPrice: '326',
    discountedPercent: '',
    modalPrice: '326'
  },
  Серебро: {
    price: '526',
    discountedPrice: '176',
    discountedPercent: '70',
    modalPrice: '526'
  },
  'Серебро+': {
    price: '1026',
    discountedPrice: '326',
    discountedPercent: '70',
    modalPrice: '1026'
  },
  Золото: {
    price: '2026',
    discountedPrice: '1026',
    discountedPercent: '50',
    modalPrice: '2026'
  },
  'Золото+': {
    price: '5026',
    discountedPrice: '2526',
    discountedPercent: '50',
    modalPrice: '5026'
  },
  Платина: {
    price: '15026',
    discountedPrice: '10026',
    discountedPercent: '30',
    modalPrice: '15026'
  },
  VIP: {
    price: '',
    discountedPrice: '100000',
    discountedPercent: '',
    modalPrice: '100000'
  }
};

const request = axios.create({
  baseURL: 'https://nomer.beeline.kg/msisdnChooser/api/v1',
  headers: {
    'content-type': 'application/json'
  }
});

export async function getNumbers(number, type, prefix) {
  const response = await request.post('/search/search', {

    searchString: number,
    actionType: type,
    prefix: prefix
  });


  try {

    const data = response.data.response.map(it => ({
      ...it,
      price: HARDCODED_PRICES[it.msisdnType].price,
      discountedPrice: HARDCODED_PRICES[it.msisdnType].discountedPrice,
      discountedPercent: HARDCODED_PRICES[it.msisdnType].discountedPercent,
      modalPrice: HARDCODED_PRICES[it.msisdnType].modalPrice
    }));
    return {data: {response: data}};

  } catch (err) {
    return {data: {response: 'Empty'}};
  }
}

export function deliveryNumber(city, name, reservdMsisdn, usersMsisdn, price) {
  return request.post('/search/delivery', {
    reservdMsisdn,
    usersMsisdn,
    name,
    city,
    service: 'nomer.beeline.kg',
    price
  });
}

export function bookingNumber(reservdMsisdn, usersMsisdn, price) {
  return request.post('/search/reserv', {
    reservdMsisdn,
    usersMsisdn,
    price,
    service: 'nomer.beeline.kg'
  });
}

